import React, {Component} from 'react';
import {tntBlue, tntFadedBlue} from '../../theme/tntColors';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

const styles = {
  button: {
    width: 34,
    height: 34,
    padding: 8,
    icon: {
      width: 18,
      height: 18,
    },
  },
};

class EditIconButton extends Component {
  render() {
    return (
      <IconButton
        style={Object.assign({}, styles.button, this.props.style)}
        iconStyle={styles.button.icon}
        onTouchTap={this.props.onTouchTap}
      >
        <EditIcon color={tntFadedBlue} hoverColor={tntBlue} />
      </IconButton>
    );
  }
}

export default EditIconButton;



// WEBPACK FOOTER //
// ./src/components/EditIconButton/EditIconButton.js